import React from 'react';
import { Skeleton } from '@/components/ui';

export default function CourseCardSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden bg-white border border-slate-200 rounded-3xl h-full shadow-sm">
      {/* Cover image skeleton */}
      <div className="relative aspect-video bg-slate-100">
        <Skeleton className="w-full h-full rounded-none" />
      </div>

      {/* Card body skeleton */}
      <div className="flex flex-col flex-1 p-5 space-y-4">
        {/* Creator row */}
        <div className="flex items-center gap-2.5">
          <Skeleton className="w-6 h-6 rounded-full" />
          <Skeleton className="h-3 w-24 rounded" />
        </div>

        {/* Title & Desc */}
        <div className="space-y-2.5 flex-1">
          <Skeleton className="h-5 w-5/6 rounded" />
          <Skeleton className="h-3 w-full rounded" />
          <Skeleton className="h-3 w-2/3 rounded" />
        </div>

        {/* Meta row */}
        <div className="flex items-center justify-between pt-2 border-t border-slate-50">
          <Skeleton className="h-3 w-16 rounded" />
          <Skeleton className="h-3 w-20 rounded" />
        </div>

        {/* Progress bar */}
        <div className="space-y-1.5 pt-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-24 rounded" />
            <Skeleton className="h-3 w-8 rounded" />
          </div>
          <Skeleton className="h-1.5 w-full rounded-full" />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-1">
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-3.5 w-16 rounded" />
            <Skeleton className="h-2.5 w-20 rounded" />
          </div>
          <Skeleton className="h-8 w-24 rounded-xl" />
        </div>
      </div>
    </div>
  );
}
